import React, { RefObject, useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { easings } from "@apps/mf-overview/src/ts/config";

/**
 * Specification of the delay before the transition is being run, from the point
 * where the in prop is set to true.
 */
const DELAY = 100;

/**
 * Specification of the transition duration in milliseconds.
 */
const DURATION = 300;

/**
 * Simple css transition that'll slide the header down from the top of the
 * viewport, when the page has initially been rendered.
 */
// tslint:disable-next-line variable-name no-reserved-keywords
export const InitialSlide: React.FC<{
  in?: boolean;
  children: (ref: RefObject<any>) => React.ReactNode;
}> = (props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      {...props}
      mountOnEnter
      timeout={DELAY + DURATION}
      classNames="layout__header__initialSlide"
      nodeRef={ref}
    >
      <>
        {props.children(ref)}

        <style jsx global>{`
          .layout__header__initialSlide-enter,
          .layout__header__initialSlide-appear {
            opacity: 0.001 !important;
            transform: translateY(-25%);
          }

          .layout__header__initialSlide-enter-active,
          .layout__header__initialSlide-appear-active {
            opacity: 1 !important;
            transform: translateY(0);

            /** Configura transition */
            transition: opacity ${DURATION}ms linear ${DELAY}ms,
              transform ${DURATION * 0.8}ms ${easings.inOutQuad} ${DELAY}ms;
          }

          .layout__header__initialSlide-enter-done,
          .layout__header__initialSlide-appear-done {
            opacity: 1 !important;
          }
        `}</style>
      </>
    </CSSTransition>
  );
};
